module.exports = __webpack_public_path__ + "static/media/festival_03.62871101.jpg";